import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ChatEmbedPage from './pages/ChatEmbedPage';
import HolidayHoursPage from './pages/HolidayHoursPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/chat" element={<ChatEmbedPage />} />
        <Route path="/holiday-hours" element={<HolidayHoursPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;